export default __webpack_public_path__ + "static/media/rocket_anim_108.81a15609.png";